import { render, staticRenderFns } from "./CodeIndex.vue?vue&type=template&id=0f323f8f&scoped=true&"
import script from "./CodeIndex.vue?vue&type=script&lang=js&"
export * from "./CodeIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f323f8f",
  null
  
)

export default component.exports